import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { VisibleCaptureProperty } from "../../../Model/CaptureProfile";
import { Polarizer } from "../../../Model/ImagerCapabilities";
import { BasicControl } from "../ImagerFeatureControls";

type PolarizerControlProps = {
  disabled: boolean;
  polarizer: Polarizer;
  captureProperty: VisibleCaptureProperty;

  onChange: (value: { polarizer: number }) => void;
};

export function PolarizerControl({ polarizer, captureProperty, disabled, onChange }: PolarizerControlProps) {

  if (captureProperty.polarizer == null) {
    throw new Error("Capture profile polarizer is null");
  }


  return (
    <BasicControl
      disabled={disabled}
      feature="Polarizer"
      id={EOpticAndCameraFeature.Polarizer}
      min={polarizer.minPolarizer}
      max={polarizer.maxPolarizer}
      value={captureProperty.polarizer}
      onValueChanged={(id, value) => {
        onChange({
          polarizer: value,
        });
      }}
      unit="°"
      step={0.1}
    />
  );
}
